import type { ReactNode } from "react";

export default function MobileDetailsDrawerItem({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) {
  return (
    <div className="flex last:border-b-0 justify-between border-b border-b-black-200 py-2 items-center">
      <span className="flex text-button-sm text-black-500">{label}</span>
      <span className="text-button-xs">{children}</span>
    </div>
  );
}
